
export default class AreaSearchBlock {
	static init() {
        const preselectedCategoryFromUri = (window.location.hash && window.location.hash.startsWith('#filter-')) ? window.location.hash.replace('#filter-', '') : null
        const preselectedCategoryElement = preselectedCategoryFromUri ? document.querySelector(`.area-search-block .filter-tag[data-category*=${preselectedCategoryFromUri}]`) : null
        if (preselectedCategoryElement) {
            AreaSearchBlock.updateCategories(preselectedCategoryElement)
            AreaSearchBlock.filterList()
        }

        window.addEventListener('input', (e) => {
            const searchInput = e.target.closest('.area-search-block--inline-filter .search-field .input');
            if (searchInput) {
                AreaSearchBlock.filterList();
            }
        });
        window.addEventListener('submit', (e) => {
            const searchForm = e.target.closest('.area-search-block--inline-filter .search-field');
            if (searchForm) {
                e.preventDefault();
            }
        });
		window.addEventListener('click', (e) => {
			const tag = e.target.closest('.area-search-block--inline-filter .filter-tag');
			if (tag) {
				e.preventDefault();
                AreaSearchBlock.updateCategories(tag);
                AreaSearchBlock.updateLocationHash(tag);
                AreaSearchBlock.filterList();
			}
		});

        document.querySelectorAll('.area-search-block .filter-tag').forEach(el => {
            let category = el.dataset.category;
            if (category === 'all') {
                return;
            }

            if (document.querySelectorAll(`[data-filter*="${category}"]`).length === 0) {
                el.classList.add('hide')
            }
        })
	}

    static updateCategories(newActiveElement) {
        let filterCatItem = document.querySelectorAll('.area-search-block .filter-tag');
        filterCatItem.forEach(link => {
            link.classList.remove('active');
        });
        newActiveElement.classList.add('active');
    }

    static updateLocationHash(newActiveElement) {
        const location = window.location.href.replace(window.location.hash, '')
        let newHash = ''
        if (newActiveElement && newActiveElement.dataset.category !== 'all') {
            newHash = `#filter-${newActiveElement.dataset.category}`
        }
        window.history.pushState({}, "", location + newHash)
    }

	static filterList() {
        let searchValue = (document.querySelector('.area-search-block .search-field .input').value || '').toLowerCase();
		let selectedFilter = document.querySelector('.area-search-block .filter-tag.active').getAttribute('data-category');
		let itemsToHide = Array.from(document.querySelectorAll(`.category-filter li:not([data-filter*='${selectedFilter}'])`));
		let itemsToMaybeShow = Array.from(document.querySelectorAll(`.category-filter [data-filter*='${selectedFilter}']`));

		if (selectedFilter === 'all') {
			itemsToHide = [];
			itemsToMaybeShow = document.querySelectorAll('.category-filter [data-filter]');
		}

		itemsToHide.forEach(el => {
			el.classList.add('hide');
			el.classList.remove('show');
		});

        itemsToMaybeShow.forEach(el => {
            if(!searchValue || el.innerText.toLowerCase().indexOf(searchValue) !== -1) {
                el.classList.remove('hide');
                el.classList.add('show');
            } else {
                el.classList.add('hide');
                el.classList.remove('show');
            }
		});

        // if a whole category is empty, hide it
        Array.from(document.querySelectorAll('.area-filter-block__letter')).forEach(el => {
            let hasVisibleItem = el.querySelector('.category-filter [data-filter]:not(.hide)');
            el.classList[hasVisibleItem ? 'remove' : 'add']('hide');
        });
	}
}
